/* Shared design tokens for the public marketing site. */
export const FONT_H = { fontFamily: "'Outfit', sans-serif" };
export const FONT_B = { fontFamily: "'Manrope', sans-serif" };
export const PRIMARY = '#6C3CE0';
export const ACCENT = '#E91E8C';
export const INK = '#0C0A14';
export const LILAC = '#F5F0FF';
export const GRADIENT_BG = 'linear-gradient(135deg, #E91E8C 0%, #6C3CE0 100%)';
export const GRADIENT_HIGHLIGHT = {
  background: GRADIENT_BG,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};
export const PILL_SHADOW = { boxShadow: '0 10px 26px rgba(108,60,224,0.28)' };
export const CARD_BORDER = { borderColor: 'rgba(108,60,224,0.10)' };

export const SIGNUP_PATH = '/login?tab=admin&mode=signup';

export const fadeUp = { hidden: { opacity: 0, y: 24 }, visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } } };
export const stagger = { visible: { transition: { staggerChildren: 0.08 } } };
export const VIEWPORT_ONCE = { once: true, margin: '-60px' };

/* Self-hosted marketing imagery (a .webp sibling exists for each file). */
export const IMG = {
  bar: '/marketing/bar.jpg',
  golfSociety: '/marketing/golf-society.jpg',
  golfCourse: '/marketing/golf-course.jpg',
  workplace: '/marketing/workplace.jpg',
  friends: '/marketing/friends.jpg',
  football: '/marketing/football.jpg',
  racing: '/marketing/racing.jpg',
  spreadsheet: '/marketing/spreadsheet.jpg',
  notebook: '/marketing/notebook.jpg',
  sportsClub: '/marketing/sports-club.jpg',
};
